import { render, staticRenderFns } from "./documetEditPen.vue?vue&type=template&id=d571a74e&"
import script from "./documetEditPen.vue?vue&type=script&lang=js&"
export * from "./documetEditPen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports